import React, { useState, useEffect } from 'react'
import ResponsiveDropdown from '@active/react-ui/ResponsiveDropdown'
import MenuItemList from '@active/react-ui/MenuItemList'
import MenuItem from '@active/react-ui/MenuItem'
import { withI18n } from '@active/react-utils/i18n'
import countriesConfig from './config/countriesConfig'

const PLACEHOLDER_FILTER_SELECT = 'react-ui.common.dropdown.notice.filterSelect'

const CountryDropdown = withI18n(props => {
  const {
    i18n,

    name,
    value,
    required,
    onChange,
    onBlur,
    registerValidate,
    htmlForm,
    onTouched,
    hasError,
  } = props

  const [inputValue, setInputValue] = useState(value)

  useEffect(() => {
    setInputValue(props.value)
  }, [props.value])

  const handleChange = selected => {
    setInputValue(selected)
    onChange && onChange(selected)
  }

  const countries = countriesConfig
    // .filter(countryConfig => countryConfig.isSupported)
    .map(({ code }) => ({
      text: i18n(`country.displayName.${code}`),
      value: code,
    }))

  return (
    <ResponsiveDropdown
      id={name}
      name={name}
      required={required}
      onBlur={onBlur}
      registerValidate={registerValidate}
      htmlform={htmlForm}
      onTouched={onTouched}
      hasError={hasError}
      value={inputValue}
      onChange={handleChange}
      placeholder={i18n('passport.common.placeholder.selectOneCountry')}
      filterplaceholder={i18n(PLACEHOLDER_FILTER_SELECT)}
    >
      <MenuItemList>
        {countries.map(({ text, value: optionValue }) => (
          <MenuItem role="option" key={optionValue} value={optionValue} aria-selected={optionValue === inputValue}>{text}</MenuItem>
        ))}
      </MenuItemList>
    </ResponsiveDropdown>
  )
})

CountryDropdown.propTypes = {
}

CountryDropdown.defaultProps = {}

export default CountryDropdown
